import React from "react";
import CachedIcon from "@mui/icons-material/Cached";
import { styled } from "@mui/material";

const StyledIcon = styled(CachedIcon)(({ theme, isLoading }) => ({
  animation: isLoading ? "spin 2s linear infinite" : "none",
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(-360deg)" },
  },
}));

const SpinningIcon = ({ isLoading }) => {
  return <StyledIcon isLoading={isLoading} />;
};

export default SpinningIcon;
